import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UserDataService } from 'src/app/providers/userData/user-data.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-header',
	standalone: false,
	templateUrl: './app-header.component.html',
	styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit, OnDestroy {
	@Input() pageTitle: string = '';
	@Input() showMenuButton: boolean = true;
	@Input() showCollegeLogo: boolean = true;

	collegeLogo: string | null = null;
	collegeLogoLoading: boolean = true;
	private destroy$ = new Subject<void>();

	constructor(private userDataService: UserDataService) {}

	async ngOnInit() {
		await this.loadCollegeLogo();

		// Listen for profile updates
		window.addEventListener('user:profile-available', this.handleProfileUpdate.bind(this));
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
		window.removeEventListener('user:profile-available', this.handleProfileUpdate.bind(this));
	}

	private async loadCollegeLogo() {
		try {
			// First try sessionStorage (fastest)
			this.collegeLogo = this.userDataService.getCollegeLogo();

			// Fallback to Ionic Storage if sessionStorage is empty
			if (!this.collegeLogo) {
				const profile = await this.userDataService.getUserProfile();
				if (profile && profile.college) {
					const logoUrl = profile.college.logoUrl ||
						(profile.college.logo ? `data:image/jpeg;base64,${profile.college.logo}` : null);

					if (logoUrl) {
						this.collegeLogo = logoUrl;
						// Save to sessionStorage for next time
						this.userDataService.saveCollegeLogo(logoUrl);
					}
				}
			}
		} catch (error) {
			console.error('Error loading college logo:', error);
		} finally {
			this.collegeLogoLoading = false;
		}
	}

	private async handleProfileUpdate() {
		await this.loadCollegeLogo();
	}

	hasCollegeLogo(): boolean {
		return !!this.collegeLogo && !this.collegeLogoLoading;
	}
}